<template>
  <div ref="demoContainer" id="demo-container" class="demo-container">
    <div ref="closeBtn" class="close-btn">✖</div>
    <div ref="demoLoading">
      <check-loading ref="checkLoading" v-if="loading"></check-loading>
    </div>
    <div v-show="!loading" ref="containerContainer" id="container"></div>
    <div id="info">3D-元素周期表</div>
    <div id="menu" v-show="false">
      <button id="table">表面</button>
      <button id="sphere">球体</button>
      <button id="helix">螺旋</button>
      <button id="grid">网格</button>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { createApp, createElement } from "vue";
import checkLoading from "@/modules/checkLoading";
import cleanTable from "@/modules/DIYcomponents/components/2_1/cleanCar/components/clean_table.vue";
import { mapState, mapGetters } from "vuex";

import { unref } from "vue";

export default {
  //import引入的组件需要注入到对象中才能使用
  name: "EmissionSource",
  //inject: ["getSourceData", "updateSourceData"],
  inject: [
    "getSourceData",
    "getScrollPage",
    "updateSourceData",
    "getFactoryArea",
    "getMaterialArea",
    "getMaterialShedList",
    "updateFactoryArea",
    "getBranchFactoryList",
    "updateLeftRightPart",
    "getInventoryId",
    "updateInventoryId",
    "updateInventoryName",
    "updateInventorySwitch",
    "updateSourceShow",
    "getEmissionLoading",
    "updateEmissionLoading",
  ],
  components: { checkLoading },
  data() {
    //这里存放数据
    return {
      customerId: this.$store.state.customerId,
      table: [],
      pageNum: 100,
      pageIndex: 0,
      rotateStatus: true,
      changePageTimer: "",
      branchFactoryList: [],
      materialShedList: [],
      sourceType: "emission",
      loading: true,
      scrollPage: 1,
      styleType: "",
      rotateTimer: null,
      animateTimer: null,
    };
  },
  setup() {
    const THREE = window.THREE_;
    const TWEEN = window.TWEEN;
    const scene = new Object();
    const camera = new Object();
    const renderer = new Object();
    const controls = new Object();
    const objects = new Array();
    const targets = {
      table: [],
      sphere: [],
      helix: [],
      grid: [],
    };
    return {
      THREE,
      TWEEN,
      scene,
      camera,
      renderer,
      controls,
      objects,
      targets,
    };
  },
  //计算属性 类似于data概念
  computed: {
    ...mapGetters({
      dialogCompontent: "getDialogCompontent",
    }),
    curStyleTypeVal() {
      return this.$store.state.styleType;
    },
  },
  //监控data中的数据变化
  watch: {
    getEmissionLoading: {
      handler(newVal, oldVal) {
        if (this.customerId !== 66) {
          this.loading = unref(newVal);
        }
      },
      deep: true,
    },
    getSourceData: {
      handler(newVal, oldVal) {
        this.sourceData = unref(newVal) || [];
        this.table = this.sourceData;
        this.sourceType = "emission";
        this.loading = false;
        this.scrollPage = Math.ceil(this.sourceData.length / this.pageNum);
        this.changePage();
      },
      deep: true,
    },
    getInventoryId: {
      handler(newVal, oldVal) {
        let inventoryId = unref(newVal);
        $(this.$refs.demoContainer).find(".element_inner").removeClass("elementSel");
        $(this.$refs.demoContainer)
          .find(".element[inventoryid='" + inventoryId + "']")
          .find(".element_inner")
          .addClass("elementSel");
      },
      deep: true,
    },
    getMaterialArea: {
      handler(newVal, oldVal) {
        let materialShedList = this.getMaterialShedList;
        this.materialShedList = unref(materialShedList);
      },
      deep: true,
    },
    getBranchFactoryList: {
      handler(newVal, oldVal) {
        this.branchFactoryList = unref(newVal);
      },
      deep: true,
    },
    getScrollPage: {
      handler(newVal, oldVal) {
        let scrollPage = unref(newVal);
        let maxPage = Math.ceil(this.sourceData.length / this.pageNum);
        if (scrollPage <= maxPage) {
          this.scrollPage = scrollPage;
          this.changePage();
        }
      },
      deep: true,
    },
    curStyleTypeVal: {
      handler(newVal, oldVal) {
        this.styleType = newVal;
      },
      deep: true,
    },
    //that.translateLeft();
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.styleType = bmeConfig.styleType;
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    //this.getSourceData();
    this.table = unref(this.getSourceData);
    this.init();
    this.animate();
    window.objects = this.objects;
    this.$emissionScroll.status = true;
  },
  activated() {
    this.$emissionScroll.status = true;
  },
  beforeUnmount() {
    if (this.rotateTimer) {
      clearTimeout(this.rotateTimer);
    }
    if (this.animateTimer) {
      window.cancelAnimationFrame(this.animateTimer);
    }
  },
  //方法集合
  methods: {
    init() {
      let THREE = this.THREE,
        TWEEN = this.TWEEN,
        that = this,
        //innerWidth = bmeConfig.INIT_WIDTH * bmeConfig.scaleRate * 2,
        //innerHeight = bmeConfig.INIT_HEIGHT * bmeConfig.scaleRate * 2;
        innerWidth = bmeConfig.INIT_WIDTH / 3,
        innerHeight = bmeConfig.INIT_HEIGHT - 25;

      if (bmeConfig.rectType) {
        (innerWidth = 1920), (innerHeight = 2160 - 25);
      }

      this.camera = new THREE.PerspectiveCamera(40, innerWidth / innerHeight, 1, 10000);

      this.camera.position.z = 2500;

      this.scene = new THREE.Scene();

      this.initTable();
      this.initGridTable();
      this.initSphere();
      this.initHelix();
      this.initGrid();

      this.scrollPage = unref(this.getScrollPage);

      this.renderer = new THREE.CSS3DRenderer();
      this.renderer.setSize(innerWidth, innerHeight);
      this.renderer.domElement.style.position = "absolute";
      //this.renderer.domElement.style.background = "rgba(255,255,255,0.2)";
      $(this.$refs.containerContainer).get(0).appendChild(this.renderer.domElement);
      //.appendChild(this.renderer.domElement);document.getElementById("container").appendChild(this.renderer.domElement);
      /*let closeDiv = $('<div class="close-btn">✖</div>');
      $(this.$refs.containerContainer).append(closeDiv);*/

      $(this.$refs.containerContainer)
        .css("position", "relative")
        .css("width", innerWidth)
        .css("height", innerHeight);

      $(this.$refs.demoLoading)
        .css("position", "absolute")
        .css("width", innerWidth)
        .css("height", innerHeight);

      $(this.$refs.closeBtn).css("left", innerWidth + "px");
      $(this.$refs.closeBtn).unbind("click");
      $(this.$refs.closeBtn).bind("click", function () {
        that.updateInventorySwitch(false);
        that.updateInventoryId(false);
        that.updateLeftRightPart(false);
        that.updateSourceShow(false);

        that.updateEmissionLoading(false);

        /*$(".bringins-block").length > 0 ? $(".bringins-block").fadeOut(500) : "";
        //this.translateLeft();
        that.updateInventorySwitch(false);
        that.updateLeftRightPart(true);
        that.updateInventoryId(false);*/
      });

      this.rotateBind(this.renderer.domElement);

      this.controls = new THREE.TrackballControls(this.camera, this.renderer.domElement);
      this.controls.rotateSpeed = 0.5;
      this.controls.noZoom = true;
      this.controls.minDistance = 500;
      this.controls.maxDistance = 6000;
      this.controls.addEventListener("change", this.render);
      window.controls = this.controls;
      window.camera = this.camera;
      window.transform = this.transform;
      window.targets = this.targets;

      this.transform(this.targets.table, 0);

      //this.transform(this.targets.table, 5000);
      /*this.transform(this.targets.helix, 2000, function () {
        that.moveFunc();
      });*/

      /*setTimeout(function () {
        that.changePage();
      }, 1000);*/
    },
    translateLeft() {
      if (bmeConfig.rectType) {
        $(this.$refs.demoContainer).addClass("left_slider_in_rectType");
      } else {
        $(this.$refs.demoContainer).addClass("left_slider_in");
      }
    },
    rotateBind(dom) {
      let that = this;
      $(dom).unbind("mouseenter");
      $(dom).bind("mouseenter", function () {
        that.stopRotate();
      });
      $(dom).unbind("mousemove");
      $(dom).bind("mousemove", function () {
        that.stopRotate();
      });
      $(dom).unbind("mouseleave");
      $(dom).bind("mouseleave", function () {
        setTimeout(function () {
          that.startRotate();
        }, 1000);
      });
    },
    changePage() {
      let that = this;
      if (that.changePageTimer) {
        clearTimeout(that.changePageTimer);
      }
      this.changePageTimer = setTimeout(function () {
        //$(".unorganized-bg").show();
        that.$emissionScroll.status = false;
        that.transform(that.targets.table, 50);

        that.rotateBind(that.renderer.domElement);

        let containerContainer = that.$refs.containerContainer;
        let elements = $(containerContainer).find(".element");

        let result = that.sourceData;

        if (elements.length > 0) {
          for (let i = 0; i < elements.length; i++) {
            let tmpIndex = (that.scrollPage - 1) * that.pageNum + i;
            if (result[tmpIndex]) {
              that.objects[i].visible = true;
              $(elements.get(i)).show();
            } else {
              that.objects[i].visible = false;
              $(elements.get(i)).hide();
            }
            /*if (that.sourceType == "emission") {
              $(elements.get(i)).removeClass("material");
            } else {
              $(elements.get(i)).addClass("material");
            }*/
            $(elements.get(i)).attr(
              "inventoryId",
              result[tmpIndex] ? result[tmpIndex]["inventoryId"] : ""
            );
            $(elements.get(i)).attr(
              "inventoryName",
              result[tmpIndex] ? result[tmpIndex]["emName"] : ""
            );
            $(elements.get(i))
              .find(".number")
              .html(tmpIndex + 1);
            $(elements.get(i))
              .find(".symbol")
              .html(
                result && result[tmpIndex]
                  ? result[tmpIndex]["emName"] && result[tmpIndex]["emName"].length > 15
                    ? result[tmpIndex]["emName"].substring(0, 15) + "..."
                    : result[tmpIndex]["emName"]
                  : "--"
              );
            $(elements.get(i))
              .find(".symbol")
              .attr(
                "title",
                result && result[tmpIndex] ? result[tmpIndex]["emName"] : "--"
              );
            $(elements.get(i))
              .find(".details")
              .html(
                result && result[tmpIndex] ? result[tmpIndex]["branchFactory"] : "--"
              );
          }
          setTimeout(function () {
            that.initHelix();
            that.transform(that.targets.helix, 2000, function () {
              that.$emissionScroll.status = true;
              that.moveFunc();
            });
          }, 500);
        }
      }, 50);
    },
    moveFunc() {
      let that = this;
      if (this.rotateTimer) {
        clearTimeout(this.rotateTimer);
      }
      this.rotateTimer = setTimeout(function () {
        if (that.$emissionScroll.status) {
          let start = window.controls._rotateStart;
          let end = window.controls._rotateEnd;
          that.calculateVal(-0.0, -0.0, start);
          that.calculateVal(-0.01, -0.0, end);
        }
        if (that.$refs.containerContainer) {
          that.moveFunc();
        }
      }, 100);
    },
    stopRotate() {
      this.$emissionScroll.status = false;
    },
    startRotate() {
      this.$emissionScroll.status = true;
    },
    calculateVal(x, y, projection) {
      let mouseOnBall = new THREE_.Vector3();
      let objectUp = new THREE_.Vector3();

      mouseOnBall.set(x, y, 0.0);

      var length = mouseOnBall.length();

      if (window.controls.noRoll) {
        if (length < Math.SQRT1_2) {
          mouseOnBall.z = Math.sqrt(1.0 - length * length);
        } else {
          mouseOnBall.z = 0.5 / length;
        }
      } else if (length > 1.0) {
        mouseOnBall.normalize();
      } else {
        mouseOnBall.z = Math.sqrt(1.0 - length * length);
      }

      window.controls._eye
        .copy(window.controls.object.position)
        .sub(window.controls.target);

      projection.copy(window.controls.object.up).setLength(mouseOnBall.y);
      projection.add(
        objectUp
          .copy(window.controls.object.up)
          .cross(window.controls._eye)
          .setLength(mouseOnBall.x)
      );
      projection.add(window.controls._eye.setLength(mouseOnBall.z));

      return projection;
    },
    render() {
      if (this.$refs.containerContainer) {
        this.renderer.render(this.scene, this.camera);
      }
    },
    transform(targets, duration, cb) {
      let THREE = this.THREE,
        TWEEN = this.TWEEN;
      TWEEN.removeAll();

      for (var i = 0; i < targets.length; i++) {
        var object = this.objects[i];
        var target = targets[i];

        new TWEEN.Tween(object.position)
          .to(
            {
              x: target.position.x,
              y: target.position.y,
              z: target.position.z,
            },
            Math.random() * duration + duration
          )
          .easing(TWEEN.Easing.Exponential.InOut)
          .start();

        new TWEEN.Tween(object.rotation)
          .to(
            {
              x: target.rotation.x,
              y: target.rotation.y,
              z: target.rotation.z,
            },
            Math.random() * duration + duration
          )
          .easing(TWEEN.Easing.Exponential.InOut)
          .start();
      }
      new TWEEN.Tween(this)
        .to({}, duration * 2)
        .onUpdate(this.render)
        .start()
        .onComplete(function () {
          if (cb) {
            cb();
          }
        });
    },
    animate() {
      let THREE = this.THREE,
        TWEEN = this.TWEEN;
      if (this.animateTimer) {
        window.cancelAnimationFrame(this.animateTimer);
      }
      this.animateTimer = requestAnimationFrame(this.animate);
      TWEEN.update();
      this.controls.update(true);
    },
    initTable() {
      let THREE = this.THREE,
        TWEEN = this.TWEEN,
        pageNum = this.pageNum,
        pageIndex = this.pageIndex,
        that = this;
      for (var i = 0; i < 100; i++) {
        var element = document.createElement("div");
        element.className = "element";

        var elementInner = document.createElement("div");
        elementInner.className = "element_inner";
        /*elementInner.style.backgroundColor =
          "rgba(0,127,127," + (Math.random() * 0.5 + 0.25) + ")";*/
        if (this.styleType === "darkBlue") {
          elementInner.style.backgroundColor =
            "rgba(0,53,86," + (Math.random() * 0.5 + 0.25) + ")";
        } else {
          elementInner.style.backgroundColor =
            "rgba(0,86,86," + (Math.random() * 0.5 + 0.25) + ")";
        }

        element.appendChild(elementInner);

        $(element).unbind("click");
        $(element).bind("click", function () {
          that.updateInventorySwitch(true);
          that.updateLeftRightPart(true);
          let inventoryId = $(this).attr("inventoryId");
          let inventoryName = $(this).attr("inventoryName");
          that.updateInventoryId({
            inventoryId: inventoryId,
            inventoryName: inventoryName,
          });
          //that.updateInventoryName(inventoryName);
          $(".element_inner").removeClass("elementSel");
          $(this).find(".element_inner").addClass("elementSel");
        });

        $(elementInner).unbind("mouseenter");
        $(elementInner).bind("mouseenter", function () {
          that.stopRotate();
          $(this).css("transform", "scale(1.8)");
        });

        $(elementInner).unbind("mousemove");
        $(elementInner).bind("mousemove", function () {
          that.stopRotate();
        });

        $(elementInner).unbind("mouseleave");
        $(elementInner).bind("mouseleave", function () {
          $(this).css("transform", "scale(1)");
        });

        var number = document.createElement("div");
        number.className = "number";
        number.textContent = i + 1;
        elementInner.appendChild(number);

        var symbol = document.createElement("div");
        symbol.className = "symbol";
        symbol.textContent = this.table[i] ? this.table[i]["emName"] : "--";
        elementInner.appendChild(symbol);

        var details = document.createElement("div");
        details.className = "details";
        details.innerHTML = this.table[i] ? this.table[i]["branchFactory"] : "--";
        elementInner.appendChild(details);

        var object = new THREE.CSS3DObject(element);
        object.position.x = Math.random() * 4000 - 2000;
        object.position.y = Math.random() * 4000 - 2000;
        object.position.z = Math.random() * 4000 - 2000;
        this.scene.add(object);

        this.objects.push(object);

        /*var object = new THREE.Object3D();
        object.position.x = this.table[i + 3] * 140 - 1330;
        object.position.y = -(this.table[i + 4] * 180) + 990;
        this.targets.table.push(object);*/
      }
    },
    initGridTable() {
      let THREE = this.THREE,
        TWEEN = this.TWEEN;
      for (var i = 0; i < this.objects.length; i++) {
        var object = new THREE.Object3D();

        object.position.x = Math.random() * 4000 - 2000;
        object.position.y = Math.random() * 4000 - 2000;
        object.position.z = Math.random() * 4000 - 2000;

        //object.position.x = this.table[i + 3] * 140 - 1330;
        //object.position.y = -(this.table[i + 4] * 180) + 990;

        this.targets.table.push(object);
      }
    },
    initSphere() {
      let THREE = this.THREE,
        TWEEN = this.TWEEN;
      var vector = new THREE.Vector3();

      for (var i = 0, l = this.objects.length; i < l; i++) {
        var phi = Math.acos(-1 + (2 * i) / l);
        var theta = Math.sqrt(l * Math.PI) * phi;

        var object = new THREE.Object3D();

        object.position.x = 800 * Math.cos(theta) * Math.sin(phi);
        object.position.y = 800 * Math.sin(theta) * Math.sin(phi);
        object.position.z = 800 * Math.cos(phi);

        vector.copy(object.position).multiplyScalar(2);

        object.lookAt(vector);

        this.targets.sphere.push(object);
      }
    },
    initHelix(type) {
      let THREE = this.THREE,
        TWEEN = this.TWEEN;
      var vector = new THREE.Vector3();

      this.targets.helix = [];

      for (var i = 0, l = this.objects.length; i < l; i++) {
        var phi = i * 0.175 + Math.PI;

        var object = new THREE.Object3D();

        object.position.x = 900 * Math.sin(phi);
        object.position.y = -(i * 8) + 450;
        object.position.z = 900 * Math.cos(phi);

        vector.x = object.position.x * 2;
        vector.y = object.position.y;
        vector.z = object.position.z * 2;

        object.lookAt(vector);

        this.targets.helix.push(object);
      }
    },
    initGrid() {
      let THREE = this.THREE,
        TWEEN = this.TWEEN;
      for (var i = 0; i < this.objects.length; i++) {
        var object = new THREE.Object3D();

        object.position.x = (i % 5) * 400 - 800;
        object.position.y = -(Math.floor(i / 5) % 5) * 400 + 800;
        object.position.z = Math.floor(i / 25) * 1000 - 2000;

        this.targets.grid.push(object);
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    // ...
    this.$emissionScroll.status = false;
    next();
  },
  //activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style lang="scss">
.demo-container {
  position: absolute;
  top: 75px;
  left: 35%;
  bottom: 0px;
  right: 0px;
  //background: rgba(0, 0, 0, 0.6);
  z-index: 10000;
  pointer-events: auto;
  transition: left 1s;
  -moz-transition: left 1s; /* Firefox 4 */
  -webkit-transition: left 1s; /* Safari and Chrome */
  -o-transition: left 1s; /* Opera */
}

.close-btn {
  position: absolute;
  left: 0px;
  top: 35px;
  width: 100px;
  height: 100px;
  font-size: 55px;
  text-align: center;
  line-height: 100px;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
}

.left_slider_in {
  left: 10% !important;
}

.left_slider_in_rectType {
  left: 4% !important;
  transform: scale(0.8);
  transform-origin: left center;
}

.material {
  zoom: 1.6;
}

.elementSel {
  background: #32a8f299 !important;
}

#demo-container {
  #info {
    position: absolute;
    width: 100%;
    color: #ffffff;
    padding: 5px;
    font-family: Monospace;
    font-size: 13px;
    font-weight: bold;
    text-align: center;
    z-index: 1;
  }

  #menu {
    position: absolute;
    bottom: 20px;
    width: 100%;
    text-align: center;
    font-family: verdana, Tahoma, Arial, Hei, "Microsoft Yahei", SimHei;
  }

  .element {
    width: 120px;
    height: 160px;
  }

  .element_inner {
    position: absolute;
    width: 120px;
    height: 160px;
    box-shadow: 0px 0px 12px rgba(0, 255, 255, 0.5);
    border: 1px solid rgba(127, 255, 255, 0.25);
    text-align: center;
    cursor: default;
  }

  .element_inner:hover {
    box-shadow: 0px 0px 12px rgba(0, 255, 255, 0.75);
    border: 1px solid rgba(127, 255, 255, 0.75);
  }

  .element_inner .number {
    position: absolute;
    top: 10px;
    right: 12px;
    font-size: 18px;
    color: rgba(127, 255, 255, 0.95);
    text-shadow: 0 0 5px rgba(255, 255, 255, 0.75);
  }

  .element_inner .symbol {
    position: absolute;
    top: 40px;
    left: 0px;
    right: 0px;
    font-size: 18px;
    font-weight: bold;
    //color: rgba(255, 255, 255, 0.75);
    color: rgba(255, 255, 255, 0.8);
    //text-shadow: 0 0 10px rgba(0, 255, 255, 0.95);
    text-shadow: 0 0 10px rgba(0, 110, 100, 0.9);
  }

  .element_inner .details {
    position: absolute;
    bottom: 15px;
    left: 0px;
    right: 0px;
    font-size: 22px;
    font-weight: bold;
    color: rgba(127, 255, 255, 0.75);
  }

  button {
    color: rgba(127, 255, 255, 0.75);
    background: transparent;
    outline: 1px solid rgba(127, 255, 255, 0.75);
    border: 0px;
    padding: 5px 10px;
    cursor: pointer;
  }
  button:hover {
    background-color: rgba(0, 255, 255, 0.5);
  }
  button:active {
    color: #000000;
    background-color: rgba(0, 255, 255, 0.75);
  }
}
</style>
